module.exports = __webpack_public_path__ + "media/components/assets/icons/videoPlaying-8f31255551b8af9d9e13a7026da28af0.png";